import React from 'react';


interface IconMapMenuProps extends React.SVGProps<SVGSVGElement> { }
const IconMapMenu: React.FC = () => (
    <svg className="icon-main-menu" width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
            d="M6.99289 8.82678L7.95508 8.16699L8.91726 8.82678L7.95508 10.23L6.99289 8.82678ZM8.632 7.06312C8.26962
              7.70828 7.95508 8.16699 7.95508 8.16699C7.95508 8.16699 7.64053 7.70828 7.27815 7.06312C6.78577 6.18653
              6.20508 4.96572 6.20508 4.08366C6.20508 3.20866 6.98758 2.33366 7.95508 2.33366C8.92258 2.33366 9.70508
              3.20866 9.70508 4.08366C9.70508 4.96572 9.12438 6.18653 8.632 7.06312ZM5.03841 4.08366C5.03841 2.60413
              6.30415 1.16699 7.95508 1.16699C9.606 1.16699 10.8717 2.60413 10.8717 4.08366C10.8717 4.66283 10.712
              5.25664 10.529 5.76372C10.3404 6.28637 10.0957 6.80075 9.86199 7.24385C9.62678 7.68977 9.39304 8.08159
              9.21857 8.36148C9.13099 8.50197 9.0575 8.61561 9.00509 8.69532C8.97886 8.7352 8.95786 8.76667 8.94295
              8.78886L8.92523 8.81509L8.91999 8.82279L8.91831 8.82525L8.9177 8.82613L8.91746 8.82648C8.91736 8.82663
              8.91726 8.82678 7.95508 8.16699C6.99289 8.82678 6.9928 8.82663 6.99269 8.82648L6.99245 8.82613L6.99185
              8.82525L6.99017 8.82279L6.98493 8.81509L6.96721 8.78886C6.9523 8.76667 6.93129 8.7352 6.90507
              8.69531C6.85266 8.61561 6.77916 8.50197 6.69159 8.36148C6.51711 8.08159 6.28337 7.68977 6.04817
              7.24385C5.81444 6.80075 5.56975 6.28637 5.38113 5.76372C5.19812 5.25664 5.03841 4.66283 5.03841
              4.08366ZM4.45508 9.33366H6.78841L7.95508 11.0837L9.12174 9.33366H11.4551L13.2051 12.2503H2.70508L4.45508
              9.33366ZM7.95508 4.95866C8.43833 4.95866 8.83008 4.56691 8.83008 4.08366C8.83008 3.60041 8.43833 3.20866
              7.95508 3.20866C7.47183 3.20866 7.08008 3.60041 7.08008 4.08366C7.08008 4.56691 7.47183 4.95866 7.95508
              4.95866Z"
        />
    </svg>
);

export default IconMapMenu;